import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["forwardedRef", "isClearable", "Icon", "iconAlt", "onIconClick", "onClear", "width", "className"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { CustomPropTypes } from '@beef/react';
import { withForwardedRef } from "../../../enhancers";
import { fakeChangeEvent, valueToPixel } from "./helpers";
import CrossIcon from "../components/assets/cross.svg";
import styles from "./parts/withIcon/styles.pcss";
var cx = classNames.bind(styles);
export var InputIcon = function InputIcon(_ref) {
  var Icon = _ref.Icon,
    title = _ref.title,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: cx('icon', {
      iconActive: !!onClick
    }),
    onClick: onClick,
    title: title,
    type: "button",
    "data-t-id": "TextInputV2-enhancers"
  }, /*#__PURE__*/React.createElement(Icon, null));
};
InputIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  Icon: PropTypes.func,
  title: PropTypes.string,
  onClick: PropTypes.func
} : {};
export default function withIcon(WrappedInput) {
  var InputWithIcon = /*#__PURE__*/function (_Component) {
    _inherits(InputWithIcon, _Component);
    var _super = _createSuper(InputWithIcon);
    function InputWithIcon() {
      var _this;
      _classCallCheck(this, InputWithIcon);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
        return _this.props.onChange('', fakeChangeEvent(event, ''));
      });
      _defineProperty(_assertThisInitialized(_this), "hasIcon", function () {
        var _this$props = _this.props,
          Icon = _this$props.Icon,
          isClearable = _this$props.isClearable;

        // indent clearable inputs even when icon is hidden to prevent padding jumping
        return isClearable || Icon;
      });
      _defineProperty(_assertThisInitialized(_this), "renderIcon", function () {
        var _this$props2 = _this.props,
          isClearable = _this$props2.isClearable,
          value = _this$props2.value,
          Icon = _this$props2.Icon,
          iconAlt = _this$props2.iconAlt,
          onIconClick = _this$props2.onIconClick;
        if (isClearable && value) {
          return /*#__PURE__*/React.createElement(InputIcon, {
            Icon: CrossIcon,
            onClick: _this.onClear,
            title: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"
          });
        }
        if (Icon) {
          return /*#__PURE__*/React.createElement(InputIcon, {
            Icon: Icon,
            onClick: onIconClick,
            title: iconAlt
          });
        }
        return null;
      });
      return _this;
    }
    _createClass(InputWithIcon, [{
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
          forwardedRef = _this$props3.forwardedRef,
          isClearable = _this$props3.isClearable,
          Icon = _this$props3.Icon,
          iconAlt = _this$props3.iconAlt,
          onIconClick = _this$props3.onIconClick,
          onClear = _this$props3.onClear,
          width = _this$props3.width,
          className = _this$props3.className,
          otherProps = _objectWithoutProperties(_this$props3, _excluded);
        return /*#__PURE__*/React.createElement("div", {
          className: cx('container', className),
          style: {
            maxWidth: valueToPixel(width)
          }
        }, /*#__PURE__*/React.createElement(WrappedInput, _extends({}, otherProps, {
          className: cx({
            inputWithIcon: this.hasIcon()
          }),
          ref: forwardedRef
        })), this.renderIcon());
      }
    }]);
    return InputWithIcon;
  }(Component);
  InputWithIcon.propTypes = process.env.NODE_ENV !== "production" ? _objectSpread(_objectSpread({}, WrappedInput.propTypes), {}, {
    /** props added by the HOC */
    Icon: PropTypes.func,
    iconAlt: PropTypes.string,
    isClearable: PropTypes.bool,
    onIconClick: PropTypes.func,
    onClear: PropTypes.func,
    /** props reused by the HOC */
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    /** is not an actual prop */
    forwardedRef: CustomPropTypes.ref
  }) : {};
  InputWithIcon.defaultProps = WrappedInput.defaultProps;

  /**
   * Override component name by prepending `Contained~`
   * to make it look nice, for example: `ContainedTextInput`
   */
  if (process.env.NODE_ENV !== 'production') {
    var WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'Input';
    InputWithIcon.displayName = WrappedComponentName;
  }
  return withForwardedRef(InputWithIcon);
}